import React from "react";
import { Link } from "react-router-dom";
import { ArrowRightIcon } from "lucide-react";
import { images, involvement } from "../../data/site";
export function InvolvementSection() {
  const [primary, ...others] = involvement;
  return <section className="px-3 md:px-5" aria-labelledby="involve-title" data-id="element-107" data-mp="1zcnlcnmc7w5c">
      <div className="mx-auto grid max-w-[1400px] gap-3 lg:grid-cols-2" data-id="element-108" data-mp="1uedqke4iyxk9">
        <div className="relative overflow-hidden rounded-[28px] md:rounded-[36px]" data-id="element-109" data-mp="1qdk4lqan7su0">
          <img src={images.landing} alt="Un pilote souriant atterrit sur une prairie au coucher du soleil" className="absolute inset-0 h-full w-full object-cover" data-id="element-110" data-mp="1ln3q02v36162" />
          <div className="absolute inset-0 bg-navy/45" aria-hidden="true" data-id="element-111" data-mp="1goa9e1ki5u1o" />
          <div className="relative flex min-h-[520px] flex-col justify-end p-8 md:p-12" data-id="element-112" data-mp="1bpyz5pqaphix">
            <h2 id="involve-title" className="max-w-md font-serif text-4xl leading-[1.1] text-cream md:text-5xl" data-id="element-113" data-mp="16q2xvy8zg472">
              Faites partie <span className="italic" data-id="element-114" data-mp="12orb00hhtx2k">de l'histoire.</span>
            </h2>
            <p className="mt-4 max-w-md text-lg text-cream/90" data-id="element-115" data-mp="28bke9dvrtvip">{primary.text}</p>
            <Link to={primary.to} className="mt-8 inline-flex w-fit items-center gap-2 rounded-full bg-red px-7 py-3.5 font-semibold text-white transition-colors duration-150 hover:bg-red-deep" data-id="element-116" data-mp="2d3u30ql5gpje">
              {primary.title}
              <ArrowRightIcon className="h-4 w-4" data-id="element-117" data-mp="23eaizhlpapmy" />
            </Link>
          </div>
        </div>

        <div className="flex flex-col gap-3" data-id="element-118" data-mp="2r4ej3ezok797">
          {others.map(item => <Link key={item.title} to={item.to} className="group flex flex-1 flex-col justify-between rounded-[28px] bg-sand p-8 transition-colors duration-150 hover:bg-sky/60 md:rounded-[36px] md:p-12" data-id="element-119" data-mp="2w2fztt9mvuhi">
              <div data-id="element-120" data-mp="2m5uuf6tpchd5">
                <h3 className="font-serif text-3xl md:text-4xl" data-id="element-121" data-mp="16mqfhwfbq65z">{item.title}</h3>
                <p className="mt-3 max-w-md text-lg text-navy-soft" data-id="element-122" data-mp="1aov58k2niinc">{item.text}</p>
              </div>
              <span className="mt-8 inline-flex items-center gap-2 font-semibold" data-id="element-123" data-mp="3dbilkpq3wcbv">
                {item.cta}
                <ArrowRightIcon className="h-4 w-4 transition-transform duration-150 group-hover:translate-x-1" data-id="element-124" data-mp="38cp5qqnck98j" />
              </span>
            </Link>)}
        </div>
      </div>
    </section>;
}